import React from 'react';
import { Box, Button } from '@material-ui/core';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { Typography, TextField, AddIcon } from '@orijinworks/frontend-commons';

const ExportFormSection = ({
    classes,
    emails,
    maxEmails = 10,
    password,
    showPassword,
    passwordError,
    handleEmailChange,
    handleAddEmail,
    handlePasswordChange,
    handleToggleShowPassword,
    isValidEmail,
}) => (
    <Box className={classes.mainCopy}>
        <Box className={classes.section}>
            <Box>
                <Typography className={classes.sectionTitle} variant="overlineLarge">
                    WHAT WILL BE EXPORTED?
                </Typography>
                <Typography className={classes.sectionBody} component="p" variant="body1">
                    You will receive a file that contains the available information for each entry
                    available in the table with the applied filters.
                </Typography>
            </Box>
            <Box margin="15px 0px">
                {emails.map((email, index) => (
                    <Box
                        key={`email-${index}`}
                        display="flex"
                        alignItems="flex-start"
                        gap={1}
                        marginBottom={1.5}
                    >
                        <TextField
                            fullWidth
                            placeholder={index === 0 ? 'Email Address*' : 'Email Address'}
                            label={index === 0 ? 'Email Address*' : 'Email Address'}
                            value={email}
                            onChange={(e) => handleEmailChange(index, e.target.value)}
                            className={classes.emailInput}
                            error={email.length > 0 && !isValidEmail(email)}
                            helperText={
                                email.length > 0 && !isValidEmail(email)
                                    ? 'Enter a valid email address'
                                    : undefined
                            }
                            inputProps={{ 'aria-label': `Email address ${index + 1}` }}
                        />
                    </Box>
                ))}
                {emails.length < maxEmails && (
                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<AddIcon aria-hidden="true" />}
                        onClick={handleAddEmail}
                        className={classes.addEmailButton}
                        aria-label="Add another email"
                    >
                        Add email
                    </Button>
                )}
            </Box>
        </Box>

        <Box className={classes.section}>
            <Box>
                <Typography className={classes.sectionTitle} variant="overlineLarge">
                    FILE PASSWORD
                </Typography>
                <Typography className={classes.sectionBody} component="p" variant="body1">
                    Set a password for the export to access the file when it is ready.
                </Typography>
            </Box>
            <TextField
                fullWidth
                type={showPassword ? 'text' : 'password'}
                placeholder="Password*"
                label="Password*"
                value={password}
                onChange={handlePasswordChange}
                className={classes.passwordInput}
                error={Boolean(passwordError)}
                helperText={passwordError}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <LockIcon sx={{ color: 'var(--navy-main)', fontSize: 20 }} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                onClick={handleToggleShowPassword}
                                edge="end"
                            >
                                {showPassword ? (
                                    <VisibilityOffIcon fontSize="small" />
                                ) : (
                                    <VisibilityIcon fontSize="small" />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                inputProps={{ 'aria-label': 'File password' }}
            />
            <Typography className={classes.passwordHelper} variant="subtitle1">
                Keep your password safe. You will need it when you receive the export email to
                access the file.
            </Typography>
        </Box>
    </Box>
);

export default ExportFormSection;
